import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/east-bethel-mn")({
  beforeLoad: () => {
    throw redirect({
      to: "/service-areas/$slug",
      params: { slug: "east-bethel" },
      statusCode: 301,
    });
  },
});
